<template>
  
  <nav class="sidebar col-md-2">
    
    <el-menu default-active="4" class="el-menu-vertical-demo" :collapse="isCollaped">

      <router-link to="/home" class="link">
        <el-menu-item index="1">
            <fa icon="home" fixed-width/>
            <span slot="title">{{ $t('home') }}</span>
        </el-menu-item>
      </router-link>

      <el-submenu index="2">
        <template slot="title">
          <fa icon="certificate" fixed-width/>
          <span slot="title">{{ $t('events') }}</span>
        </template>
        <el-menu-item index="2-1">
          <router-link to="/events" class="nav-link" active-class="active">
          {{ $t('list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-2">
          <router-link to="/events/new" class="nav-link" active-class="active">
          {{ $t('new') }}
          </router-link>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="3">
        <template slot="title">
          <fa icon="male" fixed-width/>
          <span slot="title">{{ $t('people') }}</span>
        </template>
        <el-menu-item index="3-1">
          <router-link to="/people" class="nav-link" active-class="active">
          {{ $t('list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="3-2">
          <router-link to="/people/new" class="nav-link" active-class="active">
          {{ $t('new') }}
          </router-link>
        </el-menu-item>
      </el-submenu>

      <el-submenu v-if="show" index="4">
        <template slot="title">
          <fa icon="male" fixed-width/>
          <span slot="title">{{ $t('users') }}</span>
        </template>
        <el-menu-item index="3-1">
          <router-link to="/users" class="nav-link" active-class="active">
          {{ $t('list') }}
          </router-link>
        </el-menu-item>
        <el-menu-item index="3-2">
          <router-link to="/users/new" class="nav-link" active-class="active">
          {{ $t('new') }}
          </router-link>
        </el-menu-item>
      </el-submenu>

      <router-link v-if="show" to="/health" class="link">
        <el-menu-item index="5">
          <fa icon="heartbeat" fixed-width/>
          <span slot="title">{{ $t('health') }}</span>
        </el-menu-item>
      </router-link>

      <router-link to="/help" class="link">
        <el-menu-item index="6">
          <fa icon="question-circle" fixed-width/>
          <span slot="title">{{ $t('help') }}</span>
        </el-menu-item>
      </router-link>

    </el-menu>

  </nav>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  middleware: 'auth',

  components: {
    
  },

  data() {
    
    return {
      show: false,
      isCollaped: false,
    }

  },

  computed: mapGetters({
    user: 'auth/user'
  }),

  created() {

    if (this.user) {
      if(this.user.roles[0].name === 'administrador') this.show = true;
    }
    window.addEventListener("resize", this.myEventHandler);
    this.myEventHandler();

  },
  destroyed() {

    window.removeEventListener("resize", this.myEventHandler);

  },
  methods: {

    myEventHandler(e) {
      if (window.innerWidth < 768) this.isCollaped = true;
      else this.isCollaped = false;
    }

  }
      
}
</script>

<style lang="scss">

  nav.sidebar {
    padding:0 !important;
    height: 100%;
    min-height: 94vh;
    & .el-menu-vertical-demo {
      height: 100%;
      min-height: 92vh;
    }
  }
  .nav-link {
    display: initial;
  }
  .link:hover {
    text-decoration: none;
  }

  // .el-menu {
  //   height: 100%;
  // }
  // .el-submenu__title:hover {
  //   background-color: #e6007e;
  //   color: #000;
  //   & i {
  //     color: #000;
  //   }
  // }
  // .nav-link {
  //   padding: 0;
  // }
  // .el-aside {
  //   position: fixed;
  //   top: 0;
  //   padding-left: 0; 
  //   height: 100%;
  //   min-height: 100%;
  //   & > ul {
  //     padding-top: 50px;
  //   }
  // }
  
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Sidebar.vue